import * as React from "react";
const SvgChartLegendCircle = props => <svg width="1rem" height="1rem" viewBox="0 0 12 12" fill="black" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={1} y={1} width={10} height={10} rx={5} /></svg>;
export default SvgChartLegendCircle;